import { Component, Element, Event, EventEmitter, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'biel-search-input',
  styleUrl: 'biel-search-input.css',
  shadow: true,
})
export class BielSearchInput {

  @State() searchQuery: string = '';

  @Prop() placeholderText: string = "Search or ask AI...";

  @Event() inputChanged: EventEmitter<string>;

  @Element() el: HTMLElement;

  componentDidLoad() {
    const input = this.el.shadowRoot.querySelector('input');
    if (input) {
      input.focus();
    }
  }

  handleInputChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.searchQuery = target.value;
    
    this.inputChanged.emit(this.searchQuery);
  }

  render() {
    return (
      <div class="biel-search-input-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
        <input class="search-input" type="search" placeholder={this.placeholderText} onInput={(event) => this.handleInputChange(event)} value={this.searchQuery}/>
      </div>
    );
  }
}
